export class DiagnosticReport {
  readonly #content: string;

  private constructor(content: string) {
    this.#content = content;
  }

  static of(content: string | DiagnosticReport): DiagnosticReport {
    if (content instanceof DiagnosticReport) {
      return content;
    }
    return new DiagnosticReport(content);
  }

  get content(): string {
    return this.#content;
  }

  get file(): File {
    return new File([this.#content], 'report.md', { type: 'text/markdown' });
  }
}
